import { NoDataException } from '../../../utils/exceptions/nodataexistsexception';
import { RewardPointDto, RewardPointDtoImpl } from './rewardpointdto';

export class RewardPointBuilder
{
    constructor(private rewardPointData: any)
    {
        if(rewardPointData === undefined)
        {
            throw new NoDataException("Reward Point data doesnt exists");
        }
    }

    buildAll(): RewardPointDto
    {
        return this.parseRewardPointDetailsResponse();
    }
    
    private parseRewardPointDetailsResponse(): RewardPointDto
    {
        
        let dto = new RewardPointDtoImpl();
        if(this.rewardPointData.rewardPoints)
        {
            dto.setRewardPoint(this.rewardPointData.rewardPoints);
        }

        if(this.rewardPointData.lastUpdated)
        {
            dto.setLastUpdatedDateTime(this.rewardPointData.lastUpdated);
        }   
    
        return dto;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/rewardpoint/rewardpointbuilder.ts